import { GooglePlaceDataResponseDTO } from '@core/api/dtos/response/googlePlaceData/googlePlaceData'
import { GooglePlaceData } from '@core/api/entities/googlePlaceData'

export class GooglePlaceDataMapper {
	static toEntity(dto: GooglePlaceDataResponseDTO): GooglePlaceData {
		return GooglePlaceData.create({
			populartimes: {
				Monday: dto.populartimes.Monday,
				Tuesday: dto.populartimes.Tuesday,
				Wednesday: dto.populartimes.Wednesday,
				Thursday: dto.populartimes.Thursday,
				Friday: dto.populartimes.Friday,
				Saturday: dto.populartimes.Saturday,
				Sunday: dto.populartimes.Sunday,
			},
		})
	}

	static toEntities(dtos: GooglePlaceDataResponseDTO[]): GooglePlaceData[] {
		return dtos.map(this.toEntity)
	}
}
